import React, { useMemo } from 'react'
import { Dropdown } from 'semantic-ui-react'
import { uniqueKey } from '../../../common/keys'
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares'

const DropdownOptionsMenu = ({
  activeItem,
  asIms,
  caption,
  color,
  direction,
  disabled,
  float,
  icon,
  iconn,
  ignoreCaption,
  menuButtons,
  onClick,
  upward,
  value,
}) => {

  const { _currentCaption, _labeled } = useMemo(() => {
    if (asIms) {
      if (activeItem) {
        return { _currentCaption: activeItem.name || activeItem, _labeled: true }
      } else if (caption) {
        return { _currentCaption: caption, _labeled: true }
      } else {
        return { _currentCaption: null, _labeled: false }
      }
    } else {
      const _caption = value ? value : caption
      return { _currentCaption: _caption, _labeled: true }
    }
  }, [caption, activeItem])

  const ims = useMemo(() => {
    if (!menuButtons || !asIms) return []
    const hc = (item) => {
      if (item?.oc) {
        item.oc(item.opts)
      } else if (onClick) {
        onClick(item)
      }
    }
    return <ItemMenuSquares menuItems={menuButtons} imsType={_imsTypes.dropdown} onClick={hc} />
  })

  const ddItems = useMemo(() => {
    if (!menuButtons || asIms) return []
    const x = menuButtons.map((mb, index) => {
      const { header, caption, icon, oc, opts, da, db, clickOptions } = mb
      const _opts = opts ? opts : clickOptions
      const hdrs = []
      if (header) {
        hdrs.push(<Dropdown.Header icon={icon} content={header} key={uniqueKey('ddom', 'h', index)} />)
      } else {
        hdrs.push(<Dropdown.Item icon={icon} text={caption} key={uniqueKey('ddom', index)} onClick={(e) => { oc && oc(_opts) }} />)
      }
      if (db) { hdrs.unshift(<Dropdown.Divider key={uniqueKey('ddb', 'menu', 'd1')} />) }
      if (da) { hdrs.push(<Dropdown.Divider key={uniqueKey('ddb', 'menu', 'd2')} />) }
      return hdrs
    })
    return x
  }, [menuButtons])

  const ddb = <Dropdown
    text={_currentCaption}
    icon={iconn ? iconn : icon ? icon : 'setting'}
    floating
    labeled={_labeled}
    button
    direction={direction ? direction : 'right'}
    upward={upward}
    disabled={disabled}
    className={color ? 'icon mini ' + color : 'icon mini'}
    style={{ float: float ? float : 'right' }}
  >
    <Dropdown.Menu
      className='ddom'
      style={{ padding: asIms ? '.5em !important' : null }}
    >
      {!ignoreCaption && <Dropdown.Header content={caption ? caption : 'Action'} />}
      {asIms ? ims : ddItems}
    </Dropdown.Menu>
  </Dropdown>

  return ddb
}

export default DropdownOptionsMenu
